import { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ConfirmComponent from "../../app/common/form/ConfirmComponent";

export default function BatchLettersHistoryPage() {
  const emailLogStore = useStore((s) => s.emailLogStore);
  const modalStore = useStore((s) => s.modalStore);
  const [batchInfos, setBatchInfos] = useState<{ batchId: string, subject: string, createdAt: string }[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    emailLogStore.getBatchInfos().then(setBatchInfos);
  }, [emailLogStore.getBatchInfos]);

  const handleDeleteBatch = (batchId: string) => {
    modalStore.openModal(
      <ConfirmComponent
        text={t("general.areYouSure")}
        onYes={async () => {
          await emailLogStore.deleteBatch(batchId);
          setBatchInfos(batchInfos.filter(b => b.batchId !== batchId));
          modalStore.closeModal();
        }}
        onCancel={modalStore.closeModal}
      />
    );
  };

  return (
    <>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t("emails.batchLettersHistory.title")}
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t("emails.batchLettersHistory.batchId")}</TableCell>
              <TableCell>{t("emails.batchLettersHistory.subject")}</TableCell>
              <TableCell>{t("emails.batchLettersHistory.createdAt")}</TableCell>
              <TableCell>{t("emails.batchLettersHistory.actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {batchInfos.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  {t("dataTable.noData")}
                </TableCell>
              </TableRow>
            ) : (
              batchInfos.map(info => (
                <TableRow key={info.batchId}>
                  <TableCell>{info.batchId}</TableCell>
                  <TableCell>{info.subject}</TableCell>
                  <TableCell>
                    {info.createdAt && info.createdAt !== "0001-01-01T00:00:00" && info.createdAt !== "1970-01-01T00:00:00"
                      ? new Date(info.createdAt).toLocaleString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => emailLogStore.downloadBatchPdf(info.batchId)}
                    >
                      {t("emails.batchLettersHistory.downloadBatchPdf")}
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleDeleteBatch(info.batchId)}
                      sx={{ ml: 1 }}
                    >
                      {t("emails.templates.delete")}
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}